import { create } from "zustand";
import { UserResponseDto } from "../services/auth/user";
import { authService } from "@/services/auth/auth-service";

interface AuthState {
  isAuthenticated: boolean;

  user: UserResponseDto | null;
  setUser: (user?: UserResponseDto) => void;

  loading: boolean;
  setLoading: (loading: boolean) => void;

  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => {
  const user = authService.checkLogin();
  const isAuthenticated = user !== null;

  return {
    isAuthenticated,
    user,
    setUser: (user?: UserResponseDto) => {
      if (user) set({ user, isAuthenticated: true });
      else set({ isAuthenticated: false, user });
    },
    loading: false,
    setLoading: (loading) => set({ loading }),
    logout: () => {
      authService.logout();
      set({ user: null, isAuthenticated: false });
    },
  };
});
